<div [ngClass]="props.inputClass ? props.inputClass : 'col-form-label'" [innerHtml]="textValue"></div>
